<template>
  <div>
    <app-table :id="tableId" :options="options" @action="getListAction" />
    <objetion-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { ObjetionTableHelpers } from "./ObjetionTableHelpers";

export default {
  extends: CoreLibrary,
  name: "TabAsign",
  mixins: [ObjetionTableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "pending-list",
      rowData: {},
      options: {
        url: `${actions.ANALYSIS_OBJETION}/index`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Procesar"),
            icon: "edit",
            type: "none",
            component: "objetion-modal",
            modalId: "objetion-add-edit-modal",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.$hub.$on("reload-table", this.reloadTable);
    this.options.columns = [...this.tableColumns, this.actionObj];
    // this.data();
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    evaluationObservations() {
     
        let url = `accreditationtechnical/evaluationobjetion/observationList/${this.inputs.id}`;
        this.axiosGet(url).then((response) => {
          this.observations = response.data;
        });
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#objetion-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    /**
     * $emit form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Designar equipo evaluador") {
        // this.selectedUrl = `${actions.PLANNING_TEAM}/${rowData.id}`;
        // window.location = `${actions.PLANNING_TEAM}/planning/${rowData.id}`;
      } else if (actionObj.title == this.$t("Procesar")) {
        
        this.selectedUrl = `${actions.ANALYSIS_OBJETION}/show/${rowData.id}`;
        this.openAddEditModal();
        // window.location = `${actions.ACCREDITATIONS_APPLICATIONS}/${this.rowData.id}`;
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit form confirmation modal
     */
    confirmed() {
      let url = `${actions.ACCREDITATIONS_APPLICATIONS}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#pending-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    reloadTable: function () {
      this.$hub.$emit("reload-" + this.tableId);
    },

    // data() {
    //   this.preloader = true;
    //   let url = `${actions.ACCREDITATIONS_APPLICATIONS}/index_review`;
    //   this.axiosGet(url)
    //     .then((response) => {

    //       if (response.status == 200) {
    //         this.accreditationAreaList = [
    //           { id: "", value: this.$t("select_option") },
    //           ...response.data.accreditationAreas,
    //         ];
    //         this.accreditationActivityList = [
    //           { id: "", value: this.$t("select_option") },
    //           ...response.data.accreditationActivities,
    //         ];
    //         this.accreditationTypeList = [
    //           { id: "", value: this.$t("select_option") },
    //           ...response.data.accreditationTypes,
    //         ];
    //       }
    //     })
    //     .catch(({ error }) => {
    //       console.log(error);
    //     })
    //     .finally(() => {
    //       this.preloader = false;
    //     });
    // },
  },
};
</script>
